import { useTheme } from '@mui/material';
import { CustomRadioInput, Heading4, TextL } from 'app/components';
import { ReviewStepBox, SignTypeContainer } from '../styles';

enum PaymentMethod {
  PIX = 'PIX',
  TED = 'TED',
}

interface ReviewStepPaymentMethodProps {
  paymentMethod: PaymentMethod | undefined;
  onChangePaymentMethod: (method: PaymentMethod) => void;
}

const ReviewStepPaymentMethod = ({
  paymentMethod,
  onChangePaymentMethod,
}: ReviewStepPaymentMethodProps) => {
  const theme = useTheme();

  return (
    <ReviewStepBox marginTop="16px" marginBottom="16px">
      <SignTypeContainer>
        <Heading4 style={{ color: theme.palette.brand.secondary.base }}>
          Método de pagamento:{' '}
        </Heading4>
        <div className="bullet-area">
          <div className="bullet-item">
            <CustomRadioInput
              isChecked={paymentMethod === PaymentMethod.PIX}
              handleClick={() => onChangePaymentMethod(PaymentMethod.PIX)}
            />
            <TextL>Pix</TextL>
          </div>
          <div className="bullet-item">
            <CustomRadioInput
              isChecked={paymentMethod === PaymentMethod.TED}
              handleClick={() => onChangePaymentMethod(PaymentMethod.TED)}
            />
            <TextL>TED</TextL>
          </div>
        </div>
      </SignTypeContainer>
    </ReviewStepBox>
  );
};

export default ReviewStepPaymentMethod;
